import { createContext, useCallback, useContext, useMemo, useState } from 'react';

const EndSessionDebugContext = createContext();

export function EndSessionDebugProvider({ children }) {
  const [isFirstSession, setIsFirstSession] = useState(true);
  const [debugGoodbyeDone, setDebugGoodbyeDone] = useState(false);

  const setIsFirstSessionStable = useCallback((v) => setIsFirstSession(v), []);
  const setDebugGoodbyeDoneStable = useCallback((v) => setDebugGoodbyeDone(v), []);

  const value = useMemo(() => ({
    isFirstSession,
    setIsFirstSession: setIsFirstSessionStable,
    debugGoodbyeDone,
    setDebugGoodbyeDone: setDebugGoodbyeDoneStable,
  }), [isFirstSession, setIsFirstSessionStable, debugGoodbyeDone, setDebugGoodbyeDoneStable]);

  return (
    <EndSessionDebugContext.Provider value={value}>
      {children}
    </EndSessionDebugContext.Provider>
  );
}

export function useEndSessionDebug() {
  const context = useContext(EndSessionDebugContext);
  if (!context) {
    throw new Error('useEndSessionDebug deve ser usado dentro de EndSessionDebugProvider');
  }
  return context;
}
